module.exports = __webpack_public_path__ + "static/img/波浪背景.2d3442b2.png";